import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {LOGIN_ROUTE, SIGNUP_ROUTE} from "src/app/app-routing.module";
import {AuthenticationService} from "@services";
import {AccountRecoveryUser} from "@model";

@Component({
    selector: 'app-signup-verification',
    templateUrl: './signup-verification.component.html',
    styleUrls: ['./signup-verification.component.scss'],
    standalone: false
})
export class SignupVerificationComponent implements OnInit {
  signupVerificationComponentState: SignupVerificationComponentState = SignupVerificationComponentState.SUCCESS;
  signupVerificationComponentStateType = SignupVerificationComponentState;

  constructor(private authService: AuthenticationService, private route: ActivatedRoute, private router: Router) {
  }

  /// example of a verification link
  // http://localhost:4200/signupVerification?userid=429&token=da36fa82-a126-4bc5-b9a5-fdad6914997a
  ngOnInit(): void {
    let userid: number = +this.route.snapshot.queryParams['userid'];
    let token: string = this.route.snapshot.queryParams['token'];
    if (userid && token) {
      this.authService.verification(new AccountRecoveryUser(userid, token), () => {
        this.signupVerificationComponentState = SignupVerificationComponentState.SUCCESS;
      }, () => {
        this.signupVerificationComponentState = SignupVerificationComponentState.ERROR;
      });
    }
  }

  onGoToLogin(): void {
    this.router.navigate([LOGIN_ROUTE]);
  }

  onGoToSignUp(): void {
    this.router.navigate([SIGNUP_ROUTE]);
  }
}

enum SignupVerificationComponentState {
  INITIAL,
  SUCCESS,
  ERROR,
}
